var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayerLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".layer{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "layer",
    width: 34,
    height: 34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.355 7.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.837,10.425,9.42,18.913a1.344,1.344,0,0,0,0,1.981l8.417,8.488a1.485,1.485,0,0,0,1.91.141,1.344,1.344,0,0,0,.141-2.122l-6.083-6.083h15a1.415,1.415,0,0,0,0-2.829h-15l6.083-6.083a1.344,1.344,0,0,0-.141-2.122,1.485,1.485,0,0,0-1.91.141Z",
    transform: "translate(-8.985 -10.001)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerLeft);
export default __webpack_public_path__ + "static/media/layer-left.f7c67c86.svg";
export { ForwardRef as ReactComponent };